import React, { useState } from "react";
import SideBar from "../../Components/Navbar/Sidebar";
import instance from "../../Components/Apis/axios";
import Loader from "../../Components/loader";

const MediaPlanUpload = () => {
  const [file, setFile] = useState(null);
  const [vendorCode, setVendorCode] = useState("prj_outdoor");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a PPT or PDF file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("vendor_code", vendorCode);

    setLoading(true);
    setError("");
    setResult(null);

    try {
      const { data } = await instance.post(
        "http://80.209.238.62:8000/extractor/odoads-sync",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setResult(data);
    } catch (err) {
      console.error(err);
      setError("Failed to extract media plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="containers">
      {/* Sidebar */}
      <div className="container-sidebar">
        <SideBar />
      </div>

      {/* Main Page */}
      <div className="container-pages">
        <div className="page-title">
          <h2>Media Plan Upload</h2>
        </div>

        <div className="card p-3 w-100">
          <div className="form-group mb-3">
            <label className="form-label">Upload PPT / PDF</label>
            <input
              type="file"
              className="form-control"
              accept=".ppt,.pptx,.pdf"
              onChange={handleFileChange}
            />
          </div>

          <div className="form-group mb-3">
            <label className="form-label">Vendor Code</label>
            <input
              type="text"
              className="form-control"
              value={vendorCode}
              onChange={(e) => setVendorCode(e.target.value)}
            />
          </div>

          <button
            className="btn btn-success w-25"
            onClick={handleUpload}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
        </div>

        {/* Loader */}
        {loading && <Loader />}

        {/* Error */}
        {error && (
          <div className="alert alert-danger mt-3">
            {error}
          </div>
        )}

        {/* Extracted Result */}
        {result && (
          <div className="card mt-4">
            <div className="card-header">
              Extracted Media Plan Data
            </div>
            <div className="card-body">
              <pre style={{ whiteSpace: "pre-wrap" }}>
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaPlanUpload;
